"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.random = void 0;
const random = () => Math.random();
exports.random = random;
//# sourceMappingURL=random.js.map